import Layout from "../components/Layout"
import { H1 } from "@inmagik/magik-ui"

export function Home() {
  return (
    <Layout>
      <H1>Dashboard</H1>
    </Layout>
  )
}
